import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import Table from 'common/table';
import { numberToCurrency } from 'utils/misc';
import Tag from 'common/tag/Tag.js';
import { ReactComponent as RefundIcon } from 'assets/ic-refunds.svg';
import { ReactComponent as ReversalIcon } from 'assets/ic-reversals.svg';
import { ReactComponent as PaymentIcon } from 'assets/ic-payment-attempts.svg';

const styles = (theme) => ({
  divider: {
    height: 1,
    color: theme.palette.common.black,
  },
  root: {},
  data: {
    height: 40,
  },
  dataLeft: {
    '& p': {
      color: theme.palette.common.black,
      fontSize: '20px',
    },
  },
  dataRight: {
    '& p': {
      textAlign: 'right',
      fontSize: '16px',
      color: theme.palette.common.black,
      paddingRight: '20px',
    },
  },
  head: {
    backgroundColor: theme.palette.common.white,
    padding: '20px 8px 8px 25px',
    borderRadius: theme.shape.borderRadius,
  },

  nameHead: {
    padding: '20px 0px 30px 0px',
  },
  amountPayment: {
    color: theme.palette.common.black,
  },
  amountReversal: {
    color: theme.palette.common.red,
  },
  amountRefund: {
    color: theme.palette.common.secondary,
  },
  paymentType: {
    color: theme.palette.common.primary,
  },
  totalPaid: {
    fontWeight: theme.palette.common.boldFont,
  },
  table: {},
  notation: {
    textAlign: 'right',
    marginTop: 20,
  },
});

const tableMetadata = [
  {
    id: 'transDate',
    renderingField: 'transDateStr',
    width: '20%',
    numeric: false,
    disablePadding: false,
    label: 'Date',
    alignment: 'left',
  },
  {
    id: 'paymentType',
    renderingField: 'paymentTypeStr',
    width: '20%',
    numeric: false,
    hideInMobile: true,
    disablePadding: false,
    label: 'Payment type',
    alignment: 'left',
  },
  {
    id: 'transcode',
    renderingField: 'transcodeStr',
    width: '20%',
    numeric: false,
    disablePadding: false,
    label: 'Description',
    alignment: 'left',
  },
  {
    id: 'amount',
    renderingField: 'amountFld',
    width: '20%',
    numeric: false,
    disablePadding: false,
    label: 'Amount',
    alignment: 'left',
  },
];

const amountFld = (amount, classes, localisation, transcode, errorCodeStr) => (
  <Typography
    className={
      transcode === 'RF'
        ? classes.amountRefund
        : transcode === 'PF' || errorCodeStr !== ''
        ? classes.amountReversal
        : classes.amountPayment
    }>
    {numberToCurrency(Math.abs(amount), localisation)}
  </Typography>
);

const getTransactionsForDisplay = (transactions, localisation, classes) => {
  return transactions.map((tran) => {
    let trans = { ...tran };
    const { dateFormat } = localisation.locales;
    trans.transDateStr = moment(trans.transDate).format(dateFormat);
    trans.transTypeStr = localisation.prompts.transactionType[trans.transType];
    trans.paymentTypeStr = (
      <Tag
        label={localisation.prompts.paymentType[trans.paymentType]}
        type="paymentType"
      />
    );
    trans.errorCodeStr = localisation.prompts.transErrorCode[trans.errorCode];
    trans.transcodeStr =
      trans.errorCodeStr === ''
        ? trans.isCombinedPayment
          ? 'Combined Payment'
          : localisation.prompts.transactionCode[trans.transcode]
        : 'Payment (' + trans.errorCodeStr + ')';
    //set the amount to positive amount to prevent sorting issue, since it could be negative value which returns from the DB.
    trans.amount = Math.abs(trans.totalAmount);
    trans.amountFld = amountFld(
      trans.totalAmount,
      classes,
      localisation,
      trans.transcode,
      trans.errorCodeStr
    );
    if (trans.isCombinedPayment) {
      trans.transactions.map((item) => {
        item.transcodeStr =
          localisation.prompts.transactionCode[item.transcode];
        item.amountFld = amountFld(
          item.amount,
          classes,
          localisation,
          item.transcode,
          trans.errorCodeStr
        );
      });
    }
    trans.__children = trans.isCombinedPayment ? trans.transactions : [];
    return trans;
  });
};

class Transaction extends React.PureComponent {
  render() {
    const {
      classes,
      localisation,
      transData,
      currentPage,
      onPageChange,
    } = this.props;
    const { groupedTransactions } = transData;
    const trans = Array.isArray(groupedTransactions)
      ? getTransactionsForDisplay(groupedTransactions, localisation, classes)
      : [];

    return (
      <div>
        <div className={classes.notation}>
          <PaymentIcon /> {'Payment attempt'}&nbsp;&nbsp;&nbsp;
          <ReversalIcon /> {' Reversals'}&nbsp;&nbsp;&nbsp;
          <RefundIcon /> {'Refunds'}&nbsp;&nbsp;&nbsp;
        </div>

        <div className={classes.table}>
          <Table
            data={trans}
            metadata={tableMetadata}
            enableExpandableRow={true}
            expandableColumn={'transcode'}
            noBackground={false}
            enableSorting={true}
            showFooter={true}
            showEmptyRows={true}
            currentPage={currentPage}
            onPageChange={onPageChange}
            orderBy={'transDate'}
            order={'desc'}
          />
        </div>
      </div>
    );
  }
}

Transaction.propTypes = {
  localisation: PropTypes.object,
  transData: PropTypes.object,
};

export default withStyles(styles)(Transaction);
